import { FormattedHTMLMessage } from 'react-intl';
import GuideBoxUI from './GuideBoxUI';
import '../styles/FrequentMistakes.css';
import fm_fit_size from '../img/guide/fm_fit_size.png'
import fm_fill_color from '../img/guide/fm_fill_color.png'
import fm_low_quality from '../img/guide/fm_low_quality.png'
import fm_background from '../img/guide/fm_background.png'
import format_icon_alarm from '../img/guide/format_icon_alarm.svg'
const frequentMistakesContent = [
  {
    id : 'Guide.frequentMistakes.fitSize',
    text : '<p>Make stickers visible in all mobile environments!</p>If the sticker is too small or too complex,<br/> it might not be visible.',
    guideImg : fm_fit_size
  },
  {
    id : 'Guide.frequentMistakes.fillInColor',
    text : '<p>Please fill in the surface of the sticker!</p>For stickers made using line drawing,<br/> fill the surface of the sticker with color.',
    guideImg : fm_fill_color
  },
  {
    id : 'Guide.frequentMistakes.lowImageQuality',
    text : '<p>Increase the quality of the stickers!</p>Low-quality stickers can be difficult to see<br/>depending on the mobile environment.<br/>Produce high-quality stickers by matching<br/>resolution and size.',
    guideImg : fm_low_quality
  },
  {
    id : 'Guide.frequentMistakes.background',
    text : '<p>Please make the sticker\'s background transparent!</p>Your sticker may include a background if necessary,<br/> but please delete any unnecessary background<br/>that is not related to the sticker’s concept.',
    guideImg : fm_background
  }
]


const FrequentMistakes = props => (
  <div className="frequent-mistakes">
    <GuideBoxUI
      imgIcon={format_icon_alarm}
      title={{
        id: 'Guide.frequentMistakes',
        defaultMessage :'Frequent mistakes!'
      }}
    />
    
    
    {
      frequentMistakesContent.map(content => 
        <div className="frequent-mistakes-wapper" key={content.id}>
          <img src={content.guideImg} alt=""/>
          <div style={{marginLeft:'40px', border:'1px solid #C7C7C7', width:'100%', height:'173px'}}>
            <div className="frequent-mistakes-text">
              <FormattedHTMLMessage
                id={content.id}
                defaultMessage={content.text}
              />
            </div>
          </div>
        </div>
      )
    }
  </div>

)//end frequentMistakes class

export default FrequentMistakes;
